import { render, staticRenderFns } from "./tpInfo.vue?vue&type=template&id=7c36fb9a&scoped=true&"
import script from "./tpInfo.vue?vue&type=script&lang=js&"
export * from "./tpInfo.vue?vue&type=script&lang=js&"
import style0 from "./tpInfo.vue?vue&type=style&index=0&id=7c36fb9a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c36fb9a",
  null
  
)

export default component.exports